import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import { Grid, Paper, TextField, useTheme } from "@material-ui/core";
import { DateTimePicker } from "@material-ui/pickers";
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE, STRESSOR_CHECK_PAUSE_MODE } from "./constants";
import { useStressEntryContext } from "./StressEntryContext";
import { Autocomplete } from "@material-ui/lab";
export const StressSelector = ({
  stresses,
  onStressSelection,
  selectedStressType,
}: any) => {
  const theme = useTheme();
  const { state, dispatch } = useStressEntryContext();
  return (
    <Grid container spacing={2} alignItems="center">
      {/* Select Asset */}
      <Grid item xs={4}>
        <FormControl fullWidth>
          {/* <InputLabel id="demo-simple-select-helper-label">
            Select asset
          </InputLabel>
          <Select
            disabled={selectedStressType}
            variant="filled"
            value={selectedStressType?.id ? selectedStressType.id : 0}
          >
            <MenuItem value={0}>
              <em>None</em>
            </MenuItem>
            {stresses.map((stressType: any) => (
              <MenuItem
                key={stressType.id}
                value={stressType.id}
                onClick={() => onStressSelection(stressType)}
              >
                {stressType.name}
              </MenuItem>
            ))}
          </Select> */}
          <Autocomplete
            options={stresses}
            getOptionLabel={(option: any) => option.name || ""}
            value={selectedStressType || null}
            disabled={!!selectedStressType}
            onChange={(event, newValue) => {
              onStressSelection(newValue);
            }}
            PaperComponent={(props) => (
              <Paper {...props} style={{ width: 300 }} />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select asset"
                variant="filled"
              />
            )}
          />
        </FormControl>
      </Grid>

      {/* Start Date */}
      <Grid item xs={4}>
        <DateTimePicker
          label={
            state && state.mode === STRESSOR_CHECK_IN_MODE
              ? "Start date"
              : state && state.mode === STRESSOR_CHECK_OUT_MODE
                ? "End date"
                : state && state.mode === STRESSOR_CHECK_PAUSE_MODE
                  ? "Pause Date"
                  : "Resume Date"
          }
          inputVariant="outlined"
          format="YYYY-MM-DD HH:mm:ss"
          value={state && state.stressEntryDate}
          onChange={(date: any) => {
            dispatch({
              type: "SET_STRESS_ENTRY_DATE",
              payload: { date },
            });
          }}
        />
      </Grid>
    </Grid>

  );
};
